import React from "react";

import { Card, Grid } from "@mui/material";

import { convertObjectToSelectOptions } from "../../../../templateHelpers";
import { orderDateSendToApiModes } from "../../../../variables/app";

import CardBody from "../../../../components/Card/CardBody";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import { useFormContext } from "react-hook-form";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";

function Twelve() {
  const { menukaartVestigingId } = useFormContext();
  const orderDateSendToApiModeOpties = convertObjectToSelectOptions(orderDateSendToApiModes);

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <Grid container spacing={1} style={{ maxWidth: 1400 }}>
            <Grid item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Twelve"} tKey={"vestigingen.form.twelve.headers.twelve"} />
              </h3>
            </Grid>
            <FormTextTC name={"twelvePublicApiKey"} tKey={"Public api key"} />
            <FormTextTC name={"twelveSharedSecret"} tKey={"Shared Secret"} />
            <FormTextTC name={"twelveClientId"} tKey={"Client id"} />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__serviceProduct_id" + menukaartVestigingId}
              name={"apiaccounts__serviceProduct_id"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__billProduct_id" + menukaartVestigingId}
              name={"apiaccounts__billProduct_id"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
            <FormSwitchTC
              name={"apiaccounts__twelveConvertPriceToExclVat"}
              tDefault={"Convert price to excl. VAT"}
              tKey={"vestigingen.form.twelve.label.twelveConvertPriceToExclVat"}
            />

            <FormSelectTC
              name={"apiaccounts__orderDateSendToApiMode"}
              options={orderDateSendToApiModeOpties}
              tDefault={"OrderDate sent to Api (mode)"}
              tKey={"vestigingen.form.apiaccounts.label.orderDateSendToApiMode"}
            />
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
}

export default Twelve;
